<template>
  <div>
    <div id="wynikifiltr">
      <span v-if="breadcrumb.length>0">
        {{breadcrumbTitle}}
        <template v-for="b in breadcrumb">
          <span :key="b.cpId">&middot; {{b.cpName}}</span>
        </template>
        <router-link :to="{name: routeName}" id="usfiltr">usuń filtry</router-link>
      </span>
    </div>

    <section id="tafla" v-if="categoryTileClicked">
      <button v-on:click="categoryTileClicked=null">Zamknij</button>
      <h1>{{ categoryTileClicked.name }}</h1>

      <router-link
        v-if="isCategorySelected(categoryTileClicked)"
        class="selectAll"
        :to="{name: routeName, params: {query: buildQueryForSelectAll(categoryTileClicked) ? buildQueryForSelectAll(categoryTileClicked) : null }}"
      >Usuń filtry</router-link>

      <router-link
        :to="{ name: routeName, params: { query: buildQueryForProperty(prop) ? buildQueryForProperty(prop) : null }}"
        v-for="prop in categoryTileClicked.categoryProperties"
        :key="prop.id"
        v-bind:class="{selected : isCategoryPropertySelected(prop)}"
      >{{ prop.label}} ({{ prop.value }})</router-link>
    </section>

    <section id="filtry">
      <span
        v-for="category in categories"
        v-bind:key="category.id"
        v-show="displayedCategories.includes(category.id)"
      >
        <a class="f3" href v-on:click.prevent="tileClicked(category)">
          {{category.name}}
          <img src="@/assets/img/strzalka.png" alt="strzalka" />
        </a>
        <router-link
          :to="{ name: routeName, params: { query: buildQueryForPropertyRemoved(categoryProperty) ? buildQueryForPropertyRemoved(categoryProperty) : null }}"
          class="f2"
          v-for="categoryProperty in category.categoryProperties"
          :key="categoryProperty.id"
          @click.native.stop
          v-show="isCategoryPropertySelected(categoryProperty)"
        >
          <i class="f2a">{{ categoryProperty.label }}</i>
          <i class="f2b">usuń</i>
        </router-link>
      </span>
    </section>
    <div id="wynikifiltr" v-if="items.length">
      <div id="find">
        <h3>Znaleziono {{items.length}} produktow</h3>
        <hr />
      </div>
    </div>
    <items-list :items="items"></items-list>
  </div>
</template>

<script>
import ItemsList from "./ItemsList.vue";
import axios from "axios";

export default {
  components: {
    "items-list": ItemsList
  },

  props: {
    query: {
      type: String
    },
    preQuery: {
      type: String
    },
    displayedCategories: {
      type: Array
    },
    routeName: {
      type: String
    },
    breadcrumbTitle: { type: String }
  },

  data() {
    return {
      // query: this.$route.params.query,
      env: process.env,

      categories: [],
      items: [],
      itemsFound: null,
      breadcrumb: [],

      selectedCategoryProperties: new Set(),
      selectedCategoryToCategoryPropertyExcl: new Map(),
      ddQueries: {},
      rmQueries: {},
      selAllQueries: {},
      selectedCategories: new Set(),
      categoryTileClicked: null,
      seoTitle: "",
      seoDescription: "",
      seoCanonical: "",

      currentQwithSort: new Map(),
      currentQwithFilter: new Map(),
      filter: null,
      sort: null
    };
  },

  methods: {
    tileClicked: function(category) {
      this.categoryTileClicked = category;
    },

    isCategoryPropertySelected: function(categoryProperty) {
      return this.selectedCategoryProperties.has(categoryProperty.id);
    },

    buildQueryForPropertyRemoved: function(categoryProperty) {
      return this.rmQueries[categoryProperty.id];
    },

    buildQueryForSelectAll: function(category) {
      return this.selAllQueries[category.id];
    },

    buildQueryForProperty: function(categoryProperty) {
      return this.ddQueries[categoryProperty.id];
    },

    isCategorySelected: function(category) {
      return this.selectedCategories.has(category.id);
    },

    onDataReceived: function(query, data) {
      this.items = data.items;
      this.categories = data.categories;
      this.breadcrumb = data.breadcrumb;
      this.selectedCategories = new Set(data.selectedCategories);

      this.itemsFound = data.items.length;
      // this.showMoreItems();

      let tmpMap = new Map();
      for (const key in data.scpLCcat) {
        tmpMap.set(key, new Set(data.scpLCcat[key]));
      }
      this.selectedCategoryToCategoryPropertyExcl = tmpMap;

      this.ddQueries = data.ddQ;
      this.rmQueries = data.rmQ;
      this.selAllQueries = data.sAllQ;
      this.selectedCategoryProperties = new Set(
        data.selectedCategoryProperties
      );

      if (data.seoConfig && data.seoConfig.title)
        this.seoTitle = data.seoConfig.title;
      else this.seoTitle = this.breadcrumb.map(item => ` ${item.cpName}`);

      if (data.seoConfig && data.seoConfig.description)
        this.seoDescription = data.seoConfig.description;
      else this.seoDescription = this.breadcrumb.map(item => ` ${item.cpName}`);

      if (data.seoConfig && data.seoConfig.canonical)
        this.seoCanonical = data.seoConfig.canonical;

      this.currentQwithSort = data.currentQwithSort;
      this.currentQwithFilter = data.currentQWithFilter;
      this.filter = data.filter;
      this.sort = data.sort ? data.sort.sortBy : null;

      document.dispatchEvent(new Event("page-rendered"));
    },

    executeSearch: function(q) {
      console.log(process.env.VUE_APP_API);
      axios
        .get(process.env.VUE_APP_API + "/ui/search.json", {
          params: {
            q: q,
            preSelect: this.preQuery,
            qty:999
          }
        })
        .then(response => {
          this.onDataReceived(q, response.data);
        });
    }
  },

  watch: {
    query: function(newVal) {
      console.log("q changed " + newVal);
      this.categoryTileClicked = null;
      this.executeSearch(newVal);
    }
  },

  created() {
    this.categoryTileClicked = null;
    console.log(`tiles created()`);
    this.executeSearch(this.query);
  },

  mounted() {}
};
</script>

<style scoped>
@import "./Tiles.css";
</style>